import { useEffect, useState } from "react";
import goldenCoinForCelebration from "../../../assets/coins/goldenCoinForCelebration.svg";

const GrandCoinCelebratoin = () => {
    const [removeScreen, setRemoveScreen] = useState<boolean>(false);

    useEffect(() => {
        const removeScreenTimeOut = setTimeout(() => {
            setRemoveScreen(true);
        }, 8000);
        return () => clearTimeout(removeScreenTimeOut);
    },[setRemoveScreen]);

    if (removeScreen){
        return <div></div>
    }

    return(
        <div style={{position: "absolute", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 10, overflow: "hidden"}}>
             <div className="full_screen coin_position_holder" style={{transform: "rotate(-150deg)"}}>
                <div className="full_screen center_horizontally_and_vertically" >
                    <div className="coins_wrapper">

                        <div className="relatible">
                            <div className="base one" >
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" style={{transform: "rotate(-210deg)"}} />
                            </div>
                            <div className="base two" >
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" style={{transform: "rotate(-210deg)"}} />
                            </div>
                            <div className="base three" >
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" style={{transform: "rotate(-210deg)"}} />
                            </div>
                            <div className="base four" >
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" style={{transform: "rotate(-210deg)"}} />
                            </div>
                            <div className="base five" >
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" style={{transform: "rotate(-210deg)"}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    )
}

export default GrandCoinCelebratoin;